export default __webpack_public_path__ + "static/media/struktur organisasi.d59e5c96.png";